import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 12,
	viewBox: "0 0 8 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.293 0.292969L0.585999 5.99997L6.293 11.707L7.707 10.293L3.414 5.99997L7.707 1.70697L6.293 0.292969Z",
		fill: "currentColor"
	})
});
export default SvgChevronLeft;
